import React from 'react';
import { motion } from 'framer-motion';
import { X, MessageCircle } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/pAUUzwkew5M2Jdo9P6J2GU/ChatGPT_Image_9_abr_2026,_04_58_39_p.m..png';
interface WhatsAppConfirmationModalProps {
  formData: {
    age: string;
    goal: string;
    state: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
  };
  onConfirm: () => void;
  onClose: () => void;
}
export function WhatsAppConfirmationModal({
  formData,
  onConfirm,
  onClose
}: WhatsAppConfirmationModalProps) {
  const whatsappMessage = `Hola! Acabo de completar el formulario de Life Freedom.

📋 Mis datos:
- Nombre: ${formData.firstName} ${formData.lastName}
- Edad: ${formData.age}
- Objetivo: ${formData.goal}
- Estado: ${formData.state}
- Teléfono: ${formData.phone}
- Email: ${formData.email}

Me gustaría continuar la conversación.`;
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-3 bg-black/60" onClick={onClose} data-id="element-275">
      <motion.div initial={{
      scale: 0.95,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} exit={{
      scale: 0.95,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl flex flex-col max-h-[85vh]" onClick={e => e.stopPropagation()} data-id="element-276">
        {/* Header - Compact */}
        <div className="relative bg-gradient-to-br from-primary to-primary-hover p-3 text-white flex-shrink-0" data-id="element-277">
          <button onClick={onClose} className="absolute top-2 right-2 p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Cerrar" data-id="element-278">
            <X className="w-4 h-4" data-id="element-279" />
          </button>
          <div className="flex justify-center mb-2" data-id="element-280">
            <img src={LOGO_URL} alt="Life Freedom" className="h-12 object-contain" data-id="element-281" />
          </div>
          <h2 className="text-sm font-bold text-center" data-id="element-282">
            Vista Previa del Mensaje
          </h2>
        </div>

        {/* Message Preview - Scrollable if needed */}
        <div className="p-3 flex-1 overflow-y-auto" data-id="element-283">
          <div className="bg-gray-50 rounded-lg p-2.5 border border-gray-200" data-id="element-284">
            <div className="flex items-start gap-2" data-id="element-285">
              <div className="w-8 h-8 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-286">
                <MessageCircle className="w-4 h-4 text-white" data-id="element-287" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-288">
                <p className="text-[10px] text-gray-500 mb-1" data-id="element-289">
                  Mensaje para WhatsApp
                </p>
                <div className="bg-white rounded-lg p-2 shadow-sm border border-gray-100" data-id="element-290">
                  <pre className="text-[11px] text-dark whitespace-pre-wrap font-sans leading-relaxed" data-id="element-291">
                    {whatsappMessage}
                  </pre>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-2 bg-blue-50 rounded-lg p-2 border border-blue-100" data-id="element-292">
            <p className="text-[10px] text-blue-800 text-center leading-tight" data-id="element-293">
              Al confirmar, enviaremos tu información y abriremos WhatsApp
            </p>
          </div>
        </div>

        {/* Action Button - Fixed at bottom */}
        <div className="p-3 pt-0 flex-shrink-0" data-id="element-294">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={onConfirm} className="w-full bg-[#25D366] hover:bg-[#20BA5A] text-white font-bold text-sm py-3 px-4 rounded-xl shadow-lg transition-all duration-200 flex items-center justify-center gap-2" data-id="element-295">
            <MessageCircle className="w-5 h-5" data-id="element-296" />
            Enviar y Seguir por WhatsApp
          </motion.button>
        </div>
      </motion.div>
    </motion.div>;
}